export default [
  {
    path: "",
    name: "光华赋能|科学经营|始于2003|企业培训咨询陪跑-找光华",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页"
    }
  }
];
